export const getAreEqualAddresses = (first?: string, second?: string) => first?.toLowerCase() === second?.toLowerCase();
